import { Options } from '../options.interface';
import { BANKING_PROCESSOR_API_CONFIG } from './banking-processor-api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BankingPartner, BankingPartnerDetails } from '@wizbii/utils/models';
import { Observable } from 'rxjs';

@Injectable()
export class BankingPartnerWebservice {
  readonly #http = inject(HttpClient);
  readonly #bankingProcessorApiConfig = inject(BANKING_PROCESSOR_API_CONFIG);

  readonly #baseUrl = this.#bankingProcessorApiConfig.baseUrl;

  readonly getPartner = (partnerId: string, options?: Options): Observable<BankingPartner> =>
    this.#http.get<BankingPartner>(`${this.#baseUrl}/v1/partner/${partnerId}`, options);

  readonly getPartners = (options?: Options): Observable<BankingPartner[]> =>
    this.#http.get<BankingPartner[]>(`${this.#baseUrl}/v1/partner`, options);

  readonly getPartnerListing = (country: string, options?: Options): Observable<BankingPartnerDetails[]> =>
    this.#http.get<BankingPartnerDetails[]>(`${this.#baseUrl}/v1/bank-partners/${country}`, options);
}
